import React from 'react';
import './ResultsTextContainer.css';

export default function ResultsTextContainer(props) {
    return (
        <div className="results-text-container">
              <span className="result-highlighted-text">{props.firstText}</span>
              <span className="result-white-text">{props.secondText}</span>
        </div>
    )
}
